// extracted by mini-css-extract-plugin
export default {"headerGrid":"LogsTable_headerGrid__txA+G"};